import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { useRouter } from "vue-router/composables";
import { getGalaxyInstance } from "@/app";
import { useConfig } from "@/composables/config";
import ChangePassword from "@/components/Login/ChangePassword.vue";
import LoginIndex from "@/components/Login/LoginIndex.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'Login',
    setup(__props) {
        const router = useRouter();
        const { config, isConfigLoaded } = useConfig();
        const hasToken = computed(() => {
            return router.currentRoute.query.token || router.currentRoute.query.expired_user;
        });
        const sessionCsrfToken = computed(() => {
            return getGalaxyInstance().session_csrf_token;
        });
        return { __sfc: true, router, config, isConfigLoaded, hasToken, sessionCsrfToken, ChangePassword, LoginIndex };
    }
});
